// extracted by mini-css-extract-plugin
export default {"modalBody":"Modal_modalBody__YlJMx","modalHeader":"Modal_modalHeader__k2A8M","title":"Modal_title__5Csjy","closeIcon":"Modal_closeIcon__Gcf+N"};